import { Routes, RouterModule } from '@angular/router';
import { BirthdaysComponent } from './birthdays.component';
import { AuthguardService } from '../authguard.service';
import { ListBirthdaysComponent } from './list-birthdays/list-birthdays.component';
import { EditBirthdayComponent } from './edit-birthday/edit-birthday.component';
import { CalendarBirthdayComponent } from './calendar-birthday/calendar-birthday.component';
import { ModuleWithProviders } from '@angular/core';

export const birthdayRoutes: Routes = [
    {
        path: 'birthdays',
        component: BirthdaysComponent,
        canActivate: [AuthguardService], // comment out for testing during development
        children: [
            {path: '',
                redirectTo: 'list',
                pathMatch: 'full'},
            {path: 'new',
                component: EditBirthdayComponent},
            {path: 'list',
                component: ListBirthdaysComponent},
            {path: 'edit/:id',
                component: EditBirthdayComponent},
            {path: 'calendar',
                component: CalendarBirthdayComponent}
        ]
    }
];



// WEBPACK FOOTER //
// ./src/app/birthdays/birthdays.routes.ts